import React from 'react';

import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';
import { CanonicalRegistration } from 'ha/constants/Filters';
import RadioGroup from 'ha/components/next/FormFields/RadioGroup';

interface Props {
  registration: SearchFilters.RegistrationFilterValue;
  onChange: (value: SearchFilters.RegistrationFilterValue) => void;
}

interface RegistrationOption {
  value: SearchFilters.RegistrationValue;
  title: string;
  dataTestLocator?: string;
}

export const RegistrationFilter: React.FC<Props & IntlProps> = ({
  registration,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="RegistrationFilter Title">
      {T('Registration')}
    </Typography.ParagraphTitle>

    <RadioGroup
      input={{
        value: registration as string,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value as SearchFilters.RegistrationFilterValue),
      }}
      options={
        [
          {
            value: CanonicalRegistration.Possible,
            title: T('Possible'),
            dataTestLocator: 'Filter Registration Possible',
          },
          {
            value: CanonicalRegistration.NotPossible,
            title: T('Not Possible'),
            dataTestLocator: 'Filter Registration Not Possible',
          },
        ] as RegistrationOption[]
      }
      data-test-locator="RegistrationFilter Controls"
    />
  </React.Fragment>
);

export default withIntl(RegistrationFilter);
